import PlusIcon from "../../../icons/PlusIcon";
import FormModal from "../../../Modal/modals/FormModal";

export default function OpretNyButtonBlock<U, V = U>(props: {
  disabled?: boolean;
  className?: string;
  editConfig?: FormConfig<U, V>;
  invalidateData?: InvalidateDataFunction<any>;
}) {
  const { disabled = false, className, editConfig, invalidateData } = props;
  if (!editConfig) return null;
  return (
    <div
      className={
        className ??
        "opret-ny-block d-grid gap-2 d-md-flex mt-2 justify-content-md-end"
      }
    >
      <div className="position-relative">
        <FormModal
          editConfig={editConfig}
          invalidateData={invalidateData}
          method={"post"}
          triggerProps={{
            transparent: true,
            color: "primary",
            title: "Tilføj",
            className: "has-icon px-2 justify-content-end",
            children: (
              <>
                Tilføj
                <span className="icon-bg">
                  <PlusIcon />
                </span>
              </>
            ),
          }}
        />
        {disabled && (
          <div className="tip">
            <h5 className="mb-1">Der må max. oprettes 3 interesseområder</h5>
            <p className="m-0">
              Rediger en eksisterende, eller slet en for at oprette en ny.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
